export default {
  SET_FOLDER_NAME: 'productListSetFolderName',
  SET_FILE_NAME: 'productListSetFileName',
  SET_DOCUMENT_TYPE_INFO: 'productListSetDocumentTypeInfo',
  SET_DOCUMENT_TYPE: 'productListSetDocumentType',
  SET_PRODUCT_TABLE: 'setProductTable',
  SET_PRODUCT_LIST_PARAM: 'setProductListParam',
}
